<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      title="批量修改"
      id-key="UserId"
      :data="data"
      @opened="onOpened"
      :get-data-func="() => {}"
      :save-func="() => {}"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="被调整值" prop="ChangeField">
          <el-select v-model="data.ChangeField">
            <el-option :value="0" label="折扣率%"></el-option>
            <el-option :value="1" label="成交价"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计算公式" prop="ChangeMode">
          <el-select v-model="data.ChangeMode">
            <el-option :value="0" label="加"></el-option>
            <el-option :value="1" label="减"></el-option>
            <el-option :value="2" label="乘"></el-option>
            <el-option :value="3" label="除"></el-option>
            <el-option :value="4" label="等于"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被调整值" prop="ChangeValue">
          <el-input
            type="text"
            v-model="data.ChangeValue"
            placeholder="请输入值"
          ></el-input>
        </el-form-item>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

import { puList, puListApi, getProcess } from "@/data/production/test";
// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      data: {
        Ids: [],
        ChangeField: 0,
        ChangeMode: 0,
        ChangeValue: 0,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/sa/discountPriceCustomerType").default,

      rules: {
        ChangeField: [{ required: true, message: "请选择被调整值" }],
        ChangeMode: [{ required: true, message: "请选择计算公式" }],
        ChangeValue: [{ required: true, message: "请输入被调整值" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
      console.log("data", data);
      this.data.Ids = data;
    },

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        this.$refs.dialog.isLoading = true;
        this.api.updates(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$parent.findList();
            this.$message.success(res.Msg);
            this.close(true);
          } else this.$message.error(res.Msg);
        });
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
